import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select"

export function ReconcileDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold">
            Reconcile Transaction
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-5">
          <div>
            <label className="text-sm font-medium">
              Phone Number or ID Number
            </label>
            <Input className="mt-2" placeholder="" />
          </div>

          <div>
            <label className="text-sm font-medium">Loan Id</label>
            <Select>
              <SelectTrigger className="mt-2">
                <SelectValue placeholder="Select Loan Id" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="1">Loan 1</SelectItem>
                <SelectItem value="2">Loan 2</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <DialogFooter className="mt-6 flex justify-end gap-3">
          <Button variant="default">Resolve</Button>
          <Button variant="ghost">Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}